import { createContext, useContext, useState, useEffect } from 'react';
import { userApi } from '../services/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadUser();
  }, []);

  async function loadUser() {
    try {
      setLoading(true);
      setError(null);
      const userData = await userApi.getMe();
      setUser(userData);
    } catch (err) {
      console.error('Failed to load user:', err);
      setError(err.message);
      // If unauthorized, user needs to authenticate via Cloudflare Access
      if (err.status === 401) {
        setError('Please sign in to continue');
      }
    } finally {
      setLoading(false);
    }
  }

  async function updatePreferences(preferences) {
    try {
      const updated = await userApi.updatePreferences(preferences);
      setUser(updated);
      return updated;
    } catch (err) {
      console.error('Failed to update preferences:', err);
      throw err;
    }
  }

  const value = {
    user,
    loading,
    error,
    updatePreferences,
    refreshUser: loadUser,
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}
